import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ModalComponent, TileComponent, QrComponent } from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'app-modal-help-no-camera-permissions',
	templateUrl: './modal-help-no-camera-permissions.component.html',
	styleUrls: ['./modal-help-no-camera-permissions.component.scss'],
	imports: [ModalComponent, TileComponent, QrComponent, TranslatePipe],
})
export class ModalHelpNoCameraPermissionsComponent {
	private configService = inject(ConfigService);

	@Input() isVisible: boolean;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor() {}

	get hasActiveRecording(): boolean {
		return this.configService.getCurrentConfig()?.required_recording || false;
	}

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
